import { useEffect, useRef, useState } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting.js";
import { MyTheme } from "./../colors"; // Importar los colores definidos


export const PieChart = ({ chartData, startDate, endDate }) => {
  const chartDivId = useRef(`piechart-${Math.random().toString(36).substring(2, 11)}`); // Genera un ID único para cada gráfico
  const rootRef = useRef(null); // Ref directa al root de amCharts (reemplaza useState + búsqueda en registry)
  const diaInicio = startDate
  const diaFin = endDate
  const graphicTitle = chartData.label


  useEffect(() => {
    // console.log(chartData); // Debug: descomentar si se necesita inspeccionar chartData (hay un duplicado más abajo)
    const generateChart = async () => {
      try {

        // Nota: estas variables de fecha no se usan actualmente para filtrar datos.
        // Si se requiere filtro por fechas a futuro, se recomienda usar el patrón
        // filterDataByDateRange que ya existe en DonutChart, NightingaleChart y RoseChart.
        var startDate = new Date(diaInicio).getTime();
        var endDate = new Date(diaFin).getTime();
        const endDatePlusOneDay = new Date(endDate);
        endDatePlusOneDay.setDate(endDatePlusOneDay.getDate() + 1);

        // Disponer instancia anterior antes de crear una nueva
        if (rootRef.current) {
          rootRef.current.dispose();
          rootRef.current = null;
        }

        const root = am5.Root.new(chartDivId.current);
        rootRef.current = root;
        root.setThemes([MyTheme.new(root)]);

        const newChart = root.container.children.push(
          am5percent.PieChart.new(root, {
            layout: root.verticalLayout,
          })
        );

        const pieSeries = newChart.series.push(
          am5percent.PieSeries.new(root, {
            name: "Series",
            valueField: "value",
            categoryField: "category",

          })
        );

        pieSeries.data.setAll(
          (chartData.data ?? []).map((item) => ({
            category: item.label,
            value: item.count
          }))
        );

        // var exporting = am5plugins_exporting.Exporting.new(root, {
        //   menu: am5plugins_exporting.ExportingMenu.new(root, {
        //     align: "right",
        //     valign: "bottom"
        //   })
        // });

        var title = newChart.children.push(am5.Label.new(root, {
          text: graphicTitle,
          fontSize: 20,
          x: am5.percent(50),
          y: am5.percent(0),
          centerX: am5.percent(50),
          visible: false // Ocultar el título inicialmente
        }));

        // Configuración de exportación
        var exporting = am5plugins_exporting.Exporting.new(root, {
          menu: am5plugins_exporting.ExportingMenu.new(root, {
            align: "right",
            valign: "bottom"
          }),
          pdfOptions: {
            addURL: false
          }
        });

        // Evento para mostrar el título solo durante la exportación a PDF
        exporting.events.on("exportstarted", function (event) {
          if (event.format === "pdf") {
            title.set("visible", true); // Mostrar el título solo al exportar a PDF
          }
        });

        exporting.events.on("exportfinished", function (event) {
          title.set("visible", false); // Ocultar el título nuevamente después de exportar
        });

        // Add legend
        newChart.legend = am5.Legend.new(root, {
          centerX: am5.percent(50),
          x: am5.percent(50),
          marginTop: 20,
          layout: root.horizontalLayout,
        });

      } catch (error) {
        console.error("Error al cargar las bibliotecas de AmCharts:", error);
      }
    };

    generateChart();

    // Cleanup: dispose directo via rootRef (sin búsqueda lineal en registry)
    return () => {
      if (rootRef.current) {
        rootRef.current.dispose();
        rootRef.current = null;
      }
    };
  }, [chartData, startDate, endDate]);

  return <div id={chartDivId.current} style={{ width: "100%", height: "500px" }}></div>;
};

export default PieChart;
